import { useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { CircleNotch } from '@phosphor-icons/react';
import { toast } from 'sonner';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export const AuthCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { loginWithGoogle } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Use ref to prevent double-processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const handleCallback = async () => {
      // Try hash fragment first (new flow: /dashboard#session_id=xxx)
      let sessionId = null;
      const hash = window.location.hash;
      if (hash?.includes('session_id=')) {
        const params = new URLSearchParams(hash.substring(1));
        sessionId = params.get('session_id');
      }

      // Fallback to query params (legacy flow: /auth/callback?session_id=xxx)
      if (!sessionId) {
        sessionId = searchParams.get('session_id');
      }

      const errorMsg = searchParams.get('error');

      if (errorMsg) {
        toast.error('Error de autenticación: ' + errorMsg);
        setTimeout(() => navigate('/login'), 2000);
        return;
      }

      if (!sessionId) {
        toast.error('No se recibió sesión de autenticación');
        setTimeout(() => navigate('/login'), 2000);
        return;
      }

      try {
        await loginWithGoogle(sessionId);
        toast.success('¡Bienvenido!');
        // Clear the hash fragment
        window.history.replaceState(null, '', window.location.pathname);
        let next = '/dashboard';
        try {
          const stored = sessionStorage.getItem('mm_post_login_redirect');
          if (stored && stored.startsWith('/') && !stored.startsWith('//')) next = stored;
          sessionStorage.removeItem('mm_post_login_redirect');
        } catch (_) { /* ignore */ }
        navigate(next, { replace: true });
      } catch (err) {
        console.error('Auth callback error:', err);
        toast.error('Error al procesar la autenticación');
        setTimeout(() => navigate('/login'), 2000);
      }
    };

    handleCallback();
  }, [searchParams, loginWithGoogle, navigate]);

  return (
    <div className="min-h-screen bg-zinc-100 dark:bg-zinc-950 flex items-center justify-center">
      <div className="text-center">
        <img src="/matermatch-logo.png" alt="MaterMatch" className="h-16 w-auto mx-auto mb-6" />
        <CircleNotch className="w-10 h-10 text-orange-500 animate-spin mx-auto mb-4" />
        <p className="text-zinc-600 dark:text-zinc-400">Procesando autenticación...</p>
      </div>
    </div>
  );
};
